import { AnalyticsModule } from './../../../../services/analytics/analytics.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmRegistrationComponent } from './confirm-registration.component';
import { ConfirmRegistrationService } from './confirm-registration.service';
import { KngButtonModule, KngFooterModule, KngLoaderModule } from 'kinetic-angular';

@NgModule({
	declarations: [
		ConfirmRegistrationComponent
	],
	imports: [ CommonModule,
		KngButtonModule,
		KngFooterModule,
		AnalyticsModule,
		KngLoaderModule
	],
	exports: [
		ConfirmRegistrationComponent
	],
	providers: [
		ConfirmRegistrationService
	]
})
export class ConfirmRegistrationModule {}
